<script setup lang="ts">
  import { storeToRefs } from "pinia";
  import type { LoginInfo } from "~/entities/LoginInfo";
  import type { PlanInfo } from "~/entities/PlanInfo";
  import type { TalkUserData } from "~/entities/TalkUserData";
  import { useSnackBarStore } from "~/stores/SnackBarStore";
  import { useTalkRoomStore } from "~/stores/TalkRoomStore";
  import { useTalkUserDataStore } from "~/stores/TalkUserDataStore";
  import { useHistoryStore } from "~/stores/HistoryStore";
  const historyStore = useHistoryStore();

  interface Props {
    planInfo: PlanInfo;
    loginInfo: LoginInfo;
    height: string;
  }
  const props = defineProps<Props>();

  const talkRoomStore = useTalkRoomStore();
  const talkUserDataStore = useTalkUserDataStore();
  const snackBarStore = useSnackBarStore();
  const { talkThreads } = storeToRefs(talkUserDataStore);

  const onClick = async (thread: TalkUserData) => {
    if (await talkUserDataStore.selectTalkThread(thread)) {
      const talk = thread.talk;
      // 選択されたスレッドを開く
      historyStore.to(talk.getThreadPath(props.planInfo.id));
    } else {
      snackBarStore.setError("無効なスレッドです");
    }
  };

  onUnmounted(() => {
    talkUserDataStore.stopTalkThreadsObserve();
  });
</script>

<template>
  <MoleculesTalkUserDataList
    :plan-info="planInfo"
    :login-info="loginInfo"
    :height="height"
    user-data-name="スレッド"
    :user-data-list="talkThreads"
    :talk-rooms="talkRoomStore.talkRooms"
    :talk-room-users="talkRoomStore.talkRoomUsers"
    :fetch-func="talkUserDataStore.fetchTalkThreads"
    :show-threads="true"
    @select="onClick"
  />
</template>
